<template>
  <div>

    <!--Banner Parallax - Photo équipe-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <img class="iconBanner" src="/Resources/images/icon/Pompe-a-eau_hover.png"/>
        <h1 class="bannerTitle">{{ $t('sectionBanner.title') }}</h1>
      </div>
    </section>

    <!--Team-->
    <section class="bgSectionTeam">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="6" class="txt-j sectionTeamTextPad">
          <h2 class="sectionTeamTitle">{{ $t('sectionTeam.title') }}</h2>
          <h3 class="sectionTeamSubtitle pb-30">{{ $t('sectionTeam.slogan') }}</h3>
          <p class="pb-30" v-html="$t('sectionTeam.text')"></p>
        </v-col>
      </v-row>
    </section>

    <!--History-->
    <section class="gridpad2">
      <v-row class="d-flex">
        <v-col cols="12" lg="6" class="txt-j">
          <div class="sectionHistoryTextPadLeft">
            <p v-html="$t('sectionHistory.1958')"></p>
            <p v-html="$t('sectionHistory.1973')"></p>
            <p v-html="$t('sectionHistory.1975')"></p>
            <p v-html="$t('sectionHistory.1977')"></p>
            <p v-html="$t('sectionHistory.1980')"></p>
            <p v-html="$t('sectionHistory.1996')"></p>
            <p v-html="$t('sectionHistory.1998')"></p>
            <p v-html="$t('sectionHistory.2001')"></p>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j">
          <div class="sectionHistoryTextPadRight">
            <p v-html="$t('sectionHistory.today')"></p>
            <p v-html="$t('sectionHistory.partnership')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .pb-30 { padding-bottom: 30px; }
  .gridpad2 { padding: 100px 100px; }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../public/Resources/images/Experts/equipe-bisson2.jpg');
    background-attachment: fixed;
    background-position: center 20%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .iconBanner {
    width: 55px;
    height: 55px;
  }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Team*/
  .sectionTeamTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  .sectionTeamSubtitle { color: rgba(var(--menuColor), 0.8); font-weight: 500; font-size: 22px; }
  .bgSectionTeam { background-color: rgb(var(--tierce2)); }
  .sectionTeamTextPad { padding: 70px 200px 70px 80px; }
  /*#endregion*/

  /*#region History*/
  .sectionHistoryTextPadLeft { padding: 0px 15px 0px 0px; }
  .sectionHistoryTextPadRight { padding: 0px 0px 0px 15px; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerOverlay { padding: 25px 20px; }
    .bannerTitle { font-size: 22px; }
    .gridpad2 { padding: 40px 15px; }
    .sectionTeamTextPad { padding: 30px 20px; }
    .sectionHistoryTextPadLeft { padding: 0; }
    .sectionHistoryTextPadRight { padding: 0; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .topBanner { background-attachment: scroll; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .gridpad2 { padding: 50px 25px; }
    .sectionTeamTextPad { padding: 40px 30px; }
    .sectionHistoryTextPadLeft { padding: 0; }
    .sectionHistoryTextPadRight { padding: 0; }
  }
</style>

<script>
  import pageTranslations from '../../public/Resources/i18N/experts.json';

  export default {
    name: 'experts',
    data: () => ({
      parallaxOffset: 0,
    }),
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
    },
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
    },
    components: {},
  }
</script>